<template>
  <v-app id="inspire">
    <v-overlay :value="isLoading" z-index="999999">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <template v-for="(link, index) in links">
          <v-list-item
            link
            :key="link.title"
            v-if="!link.children || !link.children.length"
            :to="link.link"
            @click="listItemClick"
          >
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :key="link.title"
            :prepend-icon="link.icon"
            :value="link.expanded"
            @click="expandMenu(index)"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="(child, i) in link.children"
              :key="i.title"
              link
              style="padding-left: 30px;"
              :to="child.link"
              @click="drawer = false"
            >
              <v-list-item-action>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <v-list-item @click="logout" v-show="!!user">
          <v-list-item-action>
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-container>
        <v-row>
          <v-col> </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="3" class="pt-9">
            <v-select
              v-show="this.$store.getters.isAuthenticated"
              :items="projects"
              :menu-props="{ maxHeight: '400' }"
              :label="activeProjectLabel"
              :value="activeProject.project_id"
              :item-text="(item) => item.name"
              :item-value="(item) => item.project_id"
              @change="updateActiveProject"
              persistent-hint
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog v-model="dialog" max-width="500px" :persistent="true">
      <v-card>
        <v-card-title>{{ transactionTitle }}</v-card-title>
        <v-card-text>
          <v-alert
            dense
            outlined
            type="error"
            v-for="error in errors"
            :key="error"
          >
            {{ error }}
          </v-alert>
          <v-row align="center" justify="center">
            <v-col cols="12" class="mx-auto">
              <div class="text-center">
                <v-btn
                  :disabled="isExpense"
                  text
                  class="ma-2"
                  color="red"
                  @click="expenseClick"
                  >Expense</v-btn
                >
                <v-btn
                  :disabled="isIncome"
                  rounded
                  text
                  class="ma-2"
                  color="green"
                  @click="incomeClick"
                  >Income</v-btn
                >
                <v-btn
                  :disabled="isTransaction"
                  rounded
                  text
                  class="ma-2"
                  color="primary"
                  @click="transferClick"
                  >Transfer</v-btn
                >
              </div>
            </v-col>
          </v-row>
          <v-form>
            <v-menu
              ref="transactionDate"
              v-model="transactionDate"
              :close-on-content-click="false"
              :return-value.sync="activeItem.date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="activeItem.date"
                  label="Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="activeItem.date"
                @dblclick:date="$refs.transactionDate.save(activeItem.date)"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.transactionDate.save(activeItem.date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="transactionPeriod"
              v-model="transactionPeriod"
              :close-on-content-click="false"
              :return-value.sync="activeItem.period"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="activeItem.period"
                  label="Period"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="activeItem.period"
                type="month"
                @dblclick:month="
                  $refs.transactionPeriod.save(activeItem.period)
                "
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="transactionPeriod = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.transactionPeriod.save(activeItem.period)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
            <p class="mb-0" style="border-bottom: 1px solid #c4c4c4">
              From Account
            </p>
            <v-treeview
              hoverable
              activatable
              :items="activeAccounts"
              item-disabled="disabled"
              selection-type="independent"
              @update:active="
                (selectedIds) =>
                  updateSelectedAccountOnSelect('from_account_id', selectedIds)
              "
            >
              <template slot="label" slot-scope="{ item }">
                <a @click="updateSelectedAccount('from_account_id', item)">{{
                  item.name
                }}</a>
              </template>
            </v-treeview>
            <p
              v-show="isTransaction"
              class="mb-0"
              style="border-bottom: 1px solid #c4c4c4"
            >
              To Account
            </p>
            <v-treeview
              v-show="isTransaction"
              hoverable
              activatable
              :items="activeAccounts"
              item-disabled="disabled"
              selection-type="independent"
              @update:active="
                (selectedIds) =>
                  updateSelectedAccountOnSelect('to_account_id', selectedIds)
              "
            >
              <template slot="label" slot-scope="{ item }">
                <a @click="updateSelectedAccount('to_account_id', item)">{{
                  item.name
                }}</a>
              </template>
            </v-treeview>
            <p
              v-show="!isTransaction"
              class="mb-0"
              style="border-bottom: 1px solid #c4c4c4"
            >
              Transaction category
            </p>
            <v-treeview
              v-show="!isTransaction"
              hoverable
              activatable
              :items="categories"
              item-disabled="disabled"
              selection-type="independent"
              @update:active="updateSelectedCategoryOnSelect"
            >
              <template slot="label" slot-scope="{ item }">
                <a @click="updateSelectedCategory(item)">{{ item.name }}</a>
              </template>
            </v-treeview>
            <v-text-field
              v-model="activeItem.amount"
              label="Amount"
              type="number"
            ></v-text-field>
            <v-textarea
              v-model="activeItem.description"
              label="Description"
              type="textarea"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Close</v-btn>
          <v-btn color="primary" @click="addTransaction">{{
            transactionActionBtn
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="this.$store.getters.isAuthenticated"
      :value="activeProjectDialog && !Object.keys(activeProject).length"
      width="500"
      :persistent="!Object.keys(activeProject).length"
    >
      <v-card>
        <v-card-title>
          Please select an active project
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-select
            v-show="this.$store.getters.isAuthenticated"
            :items="projects"
            :menu-props="{ maxHeight: '500' }"
            :label="activeProjectLabel"
            :value="activeProject.project_id"
            :item-text="(item) => item.name"
            :item-value="(item) => item.project_id"
            @change="updateActiveProject"
            persistent-hint
          >
          </v-select>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-footer color="success" padless>
      <v-row justify="center" no-gutters>
        <v-btn
          fab
          color="green accent-2"
          absolute
          top
          right
          @click="openDialog"
          v-show="!!user"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-col class="primary py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} — <strong>Teran</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "App",
  components: {},
  data: () => ({
    transactionDate: false,
    transactionPeriod: false,
    drawer: false,
    currentDate: new Date().toISOString().substr(8, 2),
    errors: [],
    activeTransaction: null,
  }),
  methods: {
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.drawer = false;
        window.location.href = "/login";
      });
    },
    transferClick() {
      this.activeItem.type = "transfer";
    },
    incomeClick() {
      this.activeItem.type = "income";
    },
    expenseClick() {
      this.activeItem.type = "expense";
    },
    resetModel() {
      this.$store.dispatch("setActiveItem", {
        date: new Date().toISOString().substr(0, 10),
        period: new Date().toISOString().substr(0, 7),
        from_account_id: "",
        to_account_id: "",
        transaction_category_id: "",
        amount: "",
        description: "",
        type: "expense",
      });
      this.errors = [];
    },
    parseErrors(result) {
      var errors = result.response.data.errors;
      let keys = Object.keys(errors);
      this.errors = [];

      keys.forEach((key) => {
        let item = errors[key];
        item.forEach((error) => {
          this.errors.push(error);
        });
      });
    },
    addTransaction() {
      var data = {
        date: this.activeItem.date,
        period: this.activeItem.period + "-" + this.currentDate,
        from_account_id: this.activeItem.from_account_id,
        transaction_category_id: this.activeItem.transaction_category_id,
        amount: this.activeItem.amount,
        description: this.activeItem.description || "",
      };
      if (this.isTransaction) {
        data = {
          to_account_id: this.activeItem.to_account_id,
          transaction_category_id: null,
          ...data,
        };
      }
      if (this.isEdit) {
        this.$store
          .dispatch("updateTransaction", { id: this.activeItem.id, data: data })
          .then(() => {
            this.closeDialog();
            this.resetModel();
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      } else {
        this.$store
          .dispatch("createTransaction", data)
          .then(() => {
            this.closeDialog();
            this.resetModel();
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      }
    },
    openDialog() {
      this.$store.dispatch("setDialog", true);
    },
    closeDialog() {
      this.$store.dispatch("setIsEdit", false);
      this.$store.dispatch("setDialog", false);
      this.resetModel();
    },
    updateActiveProject(id) {
      this.$store.commit("SET_PROJECTS_DIALOG", false);
      this.$store.dispatch("setActiveProject", id);
    },
    updateSelectedCategory(item) {
      this.activeItem.transaction_category_id = item.id;
    },
    updateSelectedCategoryOnSelect(id) {
      this.activeItem.transaction_category_id = id[0];
    },
    updateSelectedAccountOnSelect(type, id) {
      this.activeItem[type] = id[0];
    },
    updateSelectedAccount(type, item) {
      this.activeItem[type] = item.id;
    },
    listItemClick() {
      this.drawer = false;
      this.$store.dispatch("removeExpansions");
    },
    expandMenu(index) {
      this.$store.dispatch("expandMenu", index);
    },
    extractChildCategories(category) {
      let children = [];
      Array.from(category.children).forEach((child) => {
        if (
          child.project_id === this.activeProject.project_id ||
          child.project_id === null
        ) {
          child.disabled = !child.transactable;
          children.push(child);
        }

        if (child.children) {
          this.extractChildCategories(child);
        }
      });

      if (
        category.project_id === this.activeProject.project_id ||
        category.project_id === null
      ) {
        category.children = children;
      }
    },
  },
  async created() {
    if (this.$store.getters.isAuthenticated) {
      await this.$store.dispatch("loadProjects");
      this.$store.dispatch("loadAccounts");
      this.$store.dispatch("loadTransactionCategories");
    }
  },
  computed: {
    ...mapGetters({
      links: "links",
      accounts: "accounts",
      transactionCategories: "transactionCategories",
      activeItem: "activeTransaction",
      dialog: "dialog",
      isEdit: "isEdit",
      projects: "projects",
      activeProjectDialog: "activeProjectDialog",
      transactionTreeViewCategories: "transactionTreeViewCategories",
      activeProject: "activeProject",
    }),
    ...mapState({
      user: (state) => state.auth.user,
      isLoading: (state) => state.isLoading,
    }),
    activeProjectLabel() {
      if (this.$store.getters.isAuthenticated) {
        return "Active project (" + this.user.email + ")";
      }
      return "Active project";
    },
    activeAccounts() {
      if (!this.dialog) return [];
      if (this.accounts) {
        return this.accounts.filter(
          (account) =>
            !account.parent_id &&
            account.project_id === this.activeProject.project_id
        );
      }

      return [];
    },
    categories() {
      if (!this.dialog) return [];
      var copy = JSON.parse(JSON.stringify(this.transactionTreeViewCategories));
      copy = copy.filter((category) => {
        this.extractChildCategories(category);

        if (
          category.project_id === this.activeProject.project_id ||
          (category.project_id === null &&
            category.project_type === this.activeProject.type)
        ) {
          if (category.type === (this.isExpense ? "expense" : "income")) {
            return true;
          }
        }

        return false;
      });

      //we need to convert the is_main property as vuetify treeview expects a boolean, the one we have is integer
      //also we need a custom disable property for the treeview as we cannot variable in the prop
      return copy.map((category) => {
        category.is_main = !!category.is_main;
        category.disabled = !category.transactable;
        return category;
      });
    },
    fromAccountLabel() {
      if (this.isIncome) {
        return "To account";
      }
      return "From account";
    },
    transactionTitle() {
      if (!this.isEdit) {
        return "Add new transaction";
      }
      return "Edit transaction";
    },
    transactionActionBtn() {
      if (!this.isEdit) {
        return "Add";
      }
      return "Update";
    },
    isTransaction() {
      return this.activeItem.type === "transfer";
    },
    isIncome() {
      return this.activeItem.type === "income";
    },
    isExpense() {
      return this.activeItem.type === "expense";
    },
  },
};
</script>
<style>
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px !important;
}
</style>
